import castArray from 'lodash/castArray';
import isString from 'lodash/isString';
import reduce from 'lodash/reduce';
import uniq from 'lodash/uniq';

/**
 * Returns an array of all the nodes in the tree flattened out.
 * Can accept a single tree object or a collection
 *
 * @param tree
 * @returns {*}
 */
export function reduceTree(tree) {
  const recurse = (reducer, node) => {
    if (node) {
      reducer.push(node);

      if (node.children && node.children.length) {
        reduce(node.children, recurse, reducer);
      }
    }

    return reducer;
  };

  return reduce(castArray(tree), recurse, []);
}

export function getAllChildrenFromSelectedOrgIds(selectedOrgIds, organizationDict) {
  return uniq(
    selectedOrgIds.flatMap((selectedOrgId) => {
      const collectChildIds = (org, visited = new Set()) => {
        if (!org || !org.children?.length) return [];

        return org.children.flatMap((child) => {
          const childId = isString(child) ? child : child?.id;
          const childOrg = isString(child) ? organizationDict[child] : child;

          if (!childId || visited.has(childId)) {
            return [];
          }

          visited.add(childId);
          return [childId, ...collectChildIds(childOrg, visited)];
        });
      };

      return collectChildIds(organizationDict[selectedOrgId]);
    }),
  );
}

export function getEnabledLanguageIds(subscriptions) {
  return subscriptions?.productSolutions
    ?.find(({id}) => id === 'LANGUAGES')
    ?.features?.filter(({enabled}) => enabled)
    ?.map(({id}) => id);
}
